(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8587],{

/***/ 13897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_G": function() { return /* binding */ getRealestate; },
  "mW": function() { return /* binding */ getRealestateDetails; },
  "t5": function() { return /* binding */ getRealestateLog; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./shared/models/endpoits/realestate.endpoint.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var RealestateStatic;

(function (RealestateStatic) {
  RealestateStatic["RealestateList"] = "/v2/realestates";
  RealestateStatic["realestatesForSelect"] = "/v2/realestates/for-select";
})(RealestateStatic || (RealestateStatic = {}));

var RealestateDynamic = {
  /**
   * @member {string}
   * @method GET
   * @version 2.0
   * @description Get realestate details
   */
  RealestateDetail: function RealestateDetail(RealestateId) {
    return "v2/realestates/".concat(RealestateId);
  },

  /**
  * @member {string}
  * @method GET
  * @version 2.0
  * @description Send realestate log
  */
  RealEstateLog: function RealEstateLog(RealestateId) {
    return "v2/realestates/".concat(RealestateId, "/log-activity");
  }
};
var RealestateEndpoints = _objectSpread(_objectSpread({}, RealestateStatic), RealestateDynamic);
// EXTERNAL MODULE: ./api/base-services.request.ts + 1 modules
var base_services_request = __webpack_require__(11882);
;// CONCATENATED MODULE: ./api/realestate.request.ts




var getRealestate = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(filters) {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", (0,base_services_request/* getRequest */.A_)(RealestateEndpoints.RealestateList, filters).then(function (response) {
              return response === null || response === void 0 ? void 0 : response.data;
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getRealestate(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getRealestateLog = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(id) {
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", (0,base_services_request/* getRequest */.A_)(RealestateEndpoints.RealEstateLog(id)).then(function (res) {
              return res.data;
            })["catch"](function (err) {
              return err.response;
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getRealestateLog(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var getRealestateDetails = /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(id, filters) {
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", (0,base_services_request/* getRequest */.A_)(RealestateEndpoints.RealestateDetail(id), filters).then(function (response) {
              return response === null || response === void 0 ? void 0 : response.data;
            })["catch"](function (error) {
              return error.response;
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getRealestateDetails(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();

/***/ }),

/***/ 6813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ propiedad_DetailsSection; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./shared/components/contact-agent-dialog/index.tsx
var contact_agent_dialog = __webpack_require__(21689);
// EXTERNAL MODULE: ./shared/components/sanitize-html/index.tsx
var sanitize_html = __webpack_require__(77131);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(34386);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./store/property-detail/index.tsx
var property_detail = __webpack_require__(78595);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./custom-hooks/data-layer-event.hook.ts
var data_layer_event_hook = __webpack_require__(65198);
;// CONCATENATED MODULE: ./shared/models/const/utm-properties.const.ts
/**
 * 
 * @description This query is used to track the urls of the properties shared to the agents by whatsapp.
 * @returns string
 * 
 */
var UtmProperties = "utm_source=whatsapp_botton&utm_medium=boton_ws&utm_campaign=vista_propiedad";
// EXTERNAL MODULE: ./api/base-services.request.ts + 1 modules
var base_services_request = __webpack_require__(11882);
;// CONCATENATED MODULE: ./api/events/events.request.ts

var sentEvent = function sentEvent(nameEvent, agentId) {
  var body = {
    agent_id: agentId,
    event: nameEvent
  };
  return (0,base_services_request/* postRequest */.j0)("/v2/event-register", body).then(function (response) {
    return response === null || response === void 0 ? void 0 : response.data;
  });
};
// EXTERNAL MODULE: ./shared/models/enums/lead_type.enum.ts
var lead_type_enum = __webpack_require__(27734);
// EXTERNAL MODULE: ./custom-hooks/useLeadCountMutation.tsx + 2 modules
var useLeadCountMutation = __webpack_require__(26102);
// EXTERNAL MODULE: ./shared/components-pages/propiedad/context/DetailPropertyContext.tsx + 1 modules
var DetailPropertyContext = __webpack_require__(74343);
// EXTERNAL MODULE: ./shared/models/endpoits/clients/lead counter/lead.counter.adapter.ts
var lead_counter_adapter = __webpack_require__(78917);
// EXTERNAL MODULE: ./shared/components/ws-contact-group/index.tsx + 3 modules
var ws_contact_group = __webpack_require__(99225);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/agent-detail/index.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }















function CardAgent(props) {
  var _useDetailPropertyCon = (0,DetailPropertyContext/* useDetailPropertyContextHook */.U)(),
      propertyDetail = _useDetailPropertyCon.propertyDetail;

  var _useLeadCountMutation = (0,useLeadCountMutation/* default */.Z)(),
      ADD_LEAD_COUNT_M = _useLeadCountMutation.ADD_LEAD_COUNT_M;

  var router = (0,next_router.useRouter)();

  var _usePropertyDetail = (0,property_detail/* usePropertyDetail */.qd)(),
      property = _usePropertyDetail.property;

  var _useState = (0,react.useState)([]),
      agents = _useState[0],
      setAgents = _useState[1];

  var translation = (0,next_intl_cjs_production_min.useTranslations)("property");

  var _useDataLayerEvent = (0,data_layer_event_hook/* default */.Z)(),
      event = _useDataLayerEvent.event;

  (0,react.useEffect)(function () {
    var _router$query, _router$query2;

    if ((_router$query = router.query) !== null && _router$query !== void 0 && _router$query.referer || (_router$query2 = router.query) !== null && _router$query2 !== void 0 && _router$query2.areferer) {
      var _router$query3;

      setAgents((_router$query3 = router.query) !== null && _router$query3 !== void 0 && _router$query3.referer ? property.agents : [property.agency]);
    } else {
      setAgents(property.agents);
    }
  }, [property]);

  if ((agents === null || agents === void 0 ? void 0 : agents.length) == 0) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null);
  }

  var onPress = function onPress(typeEvent, pos) {
    var _router$query4, _router$query5, _agents$pos, _agents$pos2, _router$query$arefere, _router$query6, _router$query7, _router$query8, _router$query9;

    var Event = {
      event: "",
      body: {
        nombre_de_agente: (_router$query4 = router.query) !== null && _router$query4 !== void 0 && _router$query4.areferer ? null : agents[pos].name,
        nombre_de_agencia: (_router$query5 = router.query) !== null && _router$query5 !== void 0 && _router$query5.areferer ? (_agents$pos = agents[pos]) === null || _agents$pos === void 0 ? void 0 : _agents$pos.name : (_agents$pos2 = agents[pos]) === null || _agents$pos2 === void 0 ? void 0 : _agents$pos2.agency_name,
        codigo_de_propiedad: property.id,
        ubicacion_propiedad: "".concat(property.address, " ").concat(property.sector, " ").concat(property.city),
        sector: property.sector,
        ciudad: property.city,
        numero_del_agente: agents[pos].phone || agents[pos].mobile || agents[pos].phoneTwo,
        numero_del_agencia: agents[pos].phone || agents[pos].mobile || agents[pos].phoneTwo,
        numero_WhatsApp_del_agente: agents[pos].mobile || agents[pos].phone || agents[pos].phoneTwo,
        numero_WhatsApp_del_agencia: agents[pos].mobile || agents[pos].phone || agents[pos].phoneTwo,
        posicion: pos,
        codigo_de_referido: (_router$query$arefere = (_router$query6 = router.query) === null || _router$query6 === void 0 ? void 0 : _router$query6.areferer) !== null && _router$query$arefere !== void 0 ? _router$query$arefere : (_router$query7 = router.query) === null || _router$query7 === void 0 ? void 0 : _router$query7.referer,
        correo: agents[pos].email,
        agency: (_router$query8 = router.query) !== null && _router$query8 !== void 0 && _router$query8.areferer ? agents[pos].name : agents[pos].agency_name,
        typeEvent: typeEvent,
        isAgency: (_router$query9 = router.query) !== null && _router$query9 !== void 0 && _router$query9.areferer ? true : false,
        propertyType: property.realstate_type,
        price_sale: property.price,
        price_rent: property.alternate_price
      }
    };

    if (typeEvent == "whatsapp") {
      var _agents$pos$id, _agents$pos3;

      var url = "https://remaxrd.com" + router.asPath + "?".concat(UtmProperties);
      ADD_LEAD_COUNT_M(_objectSpread({}, (0,lead_counter_adapter/* default */.Z)({
        isReferred: propertyDetail.leadRefererInfo.isReferer,
        realestateId: propertyDetail.leadRefererInfo.propertyId,
        idSelected: agents[pos].id,
        isAgentReferer: propertyDetail.leadRefererInfo.isAgentReferer,
        isAgencyReferer: propertyDetail.leadRefererInfo.isAgenciesReferer,
        type: lead_type_enum/* C_LEAD_TYPE.WHATSAPP */.Pk.WHATSAPP
      })));
      event({
        event_name: "whatsapp_propiedad",
        body: Event.body
      });
      sentEvent("whatsapp_contant_agent", (_agents$pos$id = (_agents$pos3 = agents[pos]) === null || _agents$pos3 === void 0 ? void 0 : _agents$pos3.id) !== null && _agents$pos$id !== void 0 ? _agents$pos$id : -1).then(function (response) {
        return console.log(response);
      });
      window.open("https://wa.me/1".concat(agents[pos].mobile || agents[pos].phone || agents[pos].phoneTwo, "?text=Me+interesa+conocer+acerca+de+esta+propiedad.%20").concat(url), "_blank");
      return;
    } // if (typeEvent == "email") {
    //   ADD_LEAD_COUNT_M({
    //     ...leadsCounterAdapter({
    //       isReferred: propertyDetail.leadRefererInfo.isReferer,
    //       realestateId: propertyDetail.leadRefererInfo.propertyId,
    //       idSelected: agents[pos].id,
    //       isAgentReferer: propertyDetail.leadRefererInfo.isAgentReferer,
    //       isAgencyReferer: propertyDetail.leadRefererInfo.isAgenciesReferer,
    //       type: C_LEAD_TYPE.MAIL,
    //     }),
    //   });
    //   return;
    // }


    if (typeEvent == "phone") {
      var _router$query10;

      event({
        event_name: (_router$query10 = router.query) !== null && _router$query10 !== void 0 && _router$query10.areferer ? "phone_agencia_propiedad" : "phone_agente_propiedad",
        body: Event.body
      });
      ADD_LEAD_COUNT_M(_objectSpread({}, (0,lead_counter_adapter/* default */.Z)({
        isReferred: propertyDetail.leadRefererInfo.isReferer,
        realestateId: propertyDetail.leadRefererInfo.propertyId,
        idSelected: agents[pos].id,
        isAgentReferer: propertyDetail.leadRefererInfo.isAgentReferer,
        isAgencyReferer: propertyDetail.leadRefererInfo.isAgenciesReferer,
        type: lead_type_enum/* C_LEAD_TYPE.CALL */.Pk.CALL
      })));
      return;
    }

    if (typeEvent == "msg") {
      props.setExtraDataLayer(Event.body);
      props.handleMessageButton(agents[pos]);
    }
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, agents === null || agents === void 0 ? void 0 : agents.map(function (agent, i) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(ContentCard, {
      key: i
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(ContentImage, null, (0,emotion_react_browser_esm/* jsx */.tZ)("img", {
      src: agent.picture,
      alt: agent.name
    })), (0,emotion_react_browser_esm/* jsx */.tZ)(Title, null, agent.name), (0,emotion_react_browser_esm/* jsx */.tZ)(ws_contact_group/* default */.Z, {
      phone: agent.mobile || agent.phone || agent.phoneTwo,
      whatsapp: agent.mobile || agent.phone || agent.phoneTwo,
      email: agent.email,
      blockEmail: true,
      wsClick: function wsClick() {
        return onPress("whatsapp", i);
      },
      phoneClick: function phoneClick() {
        return onPress("phone", i);
      },
      emailClick: function emailClick() {
        return onPress("msg", i);
      }
    }));
  }));
}

/* harmony default export */ var agent_detail = (CardAgent);

var ContentCard = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e11o9qli9"
} : 0)( true ? {
  name: "n0e3gd",
  styles: "width:100%;height:auto;display:flex;flex-direction:column;margin:0px auto;margin-bottom:25px"
} : 0);

var ContentImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e11o9qli8"
} : 0)( true ? {
  name: "1chhdv5",
  styles: "width:100%;height:200px;justify-content:center;align-items:center;display:flex;& img{width:200px;height:200px;margin:0 auto;border-radius:50%;object-fit:contain;}"
} : 0);

var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h3",  true ? {
  target: "e11o9qli7"
} : 0)( true ? {
  name: "ts1va9",
  styles: "font-size:1.5rem;font-weight:600;color:black;margin:10px auto"
} : 0);

var MessageContact = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e11o9qli6"
} : 0)( true ? {
  name: "1u4xc2l",
  styles: "font-size:0.9rem;font-weight:500;color:black;margin:10px auto"
} : 0);

var TextInfo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e11o9qli5"
} : 0)( true ? {
  name: "u1dk5c",
  styles: "font-size:12px;font-weight:500;color:white"
} : 0);

var InfoContact = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e11o9qli4"
} : 0)( true ? {
  name: "mvg6vh",
  styles: "width:100%;height:auto;display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;margin-top:10px;column-gap:10px;& p{font-weight:500;color:var(--color-brand-grey-secondary);}"
} : 0);

var sharestylebtn = "\n    width: 100%;\n    height: 45px;\n    border-radius: 50px;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: white;\n    margin-top: 15px;\n    font-weight: 500;\n    font-size: 0.9rem;\n    letter-spacing: 0.3px;\n    transition: all 0.3s ease;\n    font-family: var(--font-family);\n    column-gap: 8px;\n";

var BtnWhatsapp = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("button",  true ? {
  target: "e11o9qli3"
} : 0)(sharestylebtn, " background-color:var(--color-brand-green-main);" + ( true ? "" : 0))));

var BtnPhone = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("button",  true ? {
  target: "e11o9qli2"
} : 0)(sharestylebtn, " background-color:black;" + ( true ? "" : 0))));

var BtnMail = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("button",  true ? {
  target: "e11o9qli1"
} : 0)(sharestylebtn, " column-gap:18px;flex-direction:row;height:52px;background-color:var(--color-brand-blue-main);" + ( true ? "" : 0))));

var StyledLink = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("a",  true ? {
  target: "e11o9qli0"
} : 0)(sharestylebtn, " text-decoration:none;" + ( true ? "" : 0))));
;// CONCATENATED MODULE: ./shared/models/functions/youtube.helper.ts
function getYouTubeVideoIdByUrl(url) {
  var reg = /^(https?:)?(\/\/)?((www\.|m\.)?youtube(-nocookie)?\.com\/((watch)?\?(feature=\w*&)?vi?=|embed\/|vi?\/|e\/)|youtu.be\/)([\w\-]{10,20})/i;
  var match = url.match(reg);

  if (match) {
    return match[9];
  } else {
    return null;
  }
}
;// CONCATENATED MODULE: ./shared/components-pages/propiedad/DetailsSection.tsx



function DetailsSection_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DetailsSection_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DetailsSection_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DetailsSection_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function DetailsSection_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }















var rentRegex = new RegExp("Alquiler", "gi");
var saleRegex = new RegExp("Venta", "gi");

function getFeatures(data) {
  var features = [];

  if (data.parking_spots) {
    features.push({
      icon: "/icons/icon_car_remaxrd.svg",
      value: data.parking_spots,
      label: "Parqueo(s)"
    });
  }

  if (data.bathrooms) {
    features.push({
      icon: "/icons/icon_bathtub_remaxrd.svg",
      value: data.bathrooms,
      label: "Baños"
    });
  }

  if (data.bedrooms) {
    features.push({
      icon: "/icons/icon_bed_remaxrd.svg",
      value: data.bedrooms,
      label: "Habitación(es)"
    });
  }

  if (data.sqm_construction || data !== null && data !== void 0 && data.sqm_land) {
    var _data$sqm_constructio;

    features.push({
      icon: "/icons/icon_rule_remaxrd.svg",
      value: ((_data$sqm_constructio = data === null || data === void 0 ? void 0 : data.sqm_construction) !== null && _data$sqm_constructio !== void 0 ? _data$sqm_constructio : data === null || data === void 0 ? void 0 : data.sqm_land) + " M\xB2",
      label: "Metros cuadrados de construcción"
    });
  }

  if (data.floor_level || data.floors_total) {
    var _data$floor_level;

    features.push({
      icon: "/icons/floors_remaxrd.svg",
      value: (_data$floor_level = data.floor_level) !== null && _data$floor_level !== void 0 ? _data$floor_level : data.floors_total,
      label: "Piso(s)"
    });
  }

  return features;
}

var handleClick = function handleClick() {
  var loanCalculator = document.getElementById("loanCalculator");
  loanCalculator === null || loanCalculator === void 0 ? void 0 : loanCalculator.scrollIntoView({
    behavior: "smooth"
  });
};

function renderImprovements(data) {
  var improvements = groupImprovements(data);
  var col1 = [];
  var col2 = [];
  var categories = Object.keys(improvements);

  for (var index = 0; index < categories.length; index++) {
    var element = improvements[categories[index]];
    var category = categories[index];

    var domElement = (0,emotion_react_browser_esm/* jsx */.tZ)(DetailsImprovementsItem, {
      key: index
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(ImprovementItemTitle, null, category), (0,emotion_react_browser_esm/* jsx */.tZ)(ImprovementItemDescription, null, element.values.join("\n")));

    if (col1.length < 5 && category !== "Mejoras") {
      col1.push(domElement);
    } else {
      col2.push(domElement);
    }
  }

  if (!col1.length) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(DetailsImprovementColumns, null, col2);
  } else {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(DetailsImprovementColumns, null, col1), (0,emotion_react_browser_esm/* jsx */.tZ)(DetailsImprovementColumns, null, col2));
  }
}

function groupImprovements(data) {
  var _data$full_improvemen = data.full_improvements,
      full_improvements = _data$full_improvemen === void 0 ? [] : _data$full_improvemen;
  var groupImprovements = {};

  for (var index = 0; index < full_improvements.length; index++) {
    var element = full_improvements[index];
    var category = (0,lodash.replace)((0,lodash.replace)(element.name, "&oacute;", "ó"), "&iacute;", "í");
    var value = (0,lodash.replace)(element.value, "&iacute;", "í");

    if (groupImprovements.hasOwnProperty(category)) {
      groupImprovements[category].values.push(value);
    } else {
      groupImprovements[category] = {
        values: [value]
      };
    }
  }

  return groupImprovements;
}

var setVideoList = function setVideoList(videos) {
  return videos === null || videos === void 0 ? void 0 : videos.map(function (video) {
    return DetailsSection_objectSpread(DetailsSection_objectSpread({}, video), {}, {
      path: getYouTubeVideoIdByUrl(video.path)
    });
  }).filter(function (video) {
    return video.path;
  }).map(function (video) {
    return DetailsSection_objectSpread(DetailsSection_objectSpread({}, video), {}, {
      path: "https://youtube.com/embed/" + video.path
    });
  });
};

function DetailsSection(props) {
  var _data$sector, _data$city, _router$query, _router$query2, _router$query3;

  var _useLeadCountMutation = (0,useLeadCountMutation/* default */.Z)(),
      ADD_LEAD_COUNT_M = _useLeadCountMutation.ADD_LEAD_COUNT_M;

  var data = props.data,
      realestateId = props.realestateId;

  var _useState = (0,react.useState)(null),
      extraDataLayer = _useState[0],
      setExtraDataLayer = _useState[1];

  var _useState2 = (0,react.useState)(false),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0,react.useState)(),
      selectedAgent = _useState3[0],
      setSelectedAgent = _useState3[1];

  var _useState4 = (0,react.useState)(true),
      clamped = _useState4[0],
      setClamped = _useState4[1];

  var _useState5 = (0,react.useState)(true),
      clampedVideos = _useState5[0],
      setClampedVideos = _useState5[1];

  var _useState6 = (0,react.useState)(null),
      refDescription = _useState6[0],
      setRefDescription = _useState6[1];

  var _useState7 = (0,react.useState)(true),
      showButton = _useState7[0],
      setShowButton = _useState7[1];

  var handleToggleDescription = function handleToggleDescription() {
    return setClamped(!clamped);
  };

  var handleToggleVideosClamp = function handleToggleVideosClamp() {
    return setClampedVideos(!clampedVideos);
  };

  var videosList = (0,react.useMemo)(function () {
    return setVideoList(data.videos);
  }, [data.videos]);

  var _useState8 = (0,react.useState)(null),
      agent = _useState8[0],
      setAgent = _useState8[1];

  var router = (0,next_router.useRouter)();
  var translation = (0,next_intl_cjs_production_min.useTranslations)("property");
  var sector = (_data$sector = data.sector) === null || _data$sector === void 0 ? void 0 : _data$sector.toLowerCase();
  var city = (_data$city = data.city) === null || _data$city === void 0 ? void 0 : _data$city.toLowerCase();
  var renderSector = sector ? sector + ", " : "";

  var handleOpenModal = function handleOpenModal(agent) {
    setOpen(true);
    setSelectedAgent(agent);
  };

  var handleCloseModal = function handleCloseModal() {
    setOpen(false);
    setSelectedAgent(null);
  };

  var onCallBackSubmitContactModal = function onCallBackSubmitContactModal() {
    if (window) {
      var params = new URL(window.location.href).searchParams;
      var propertiesId = realestateId;
      var isAgencyReferer = params.get("areferer");
      var isAgentReferer = params.get("referer");
      var codeReferer = isAgencyReferer || isAgentReferer || selectedAgent;
      var isReferer = codeReferer ? true : false;

      if (propertiesId) {
        ADD_LEAD_COUNT_M(DetailsSection_objectSpread({}, (0,lead_counter_adapter/* default */.Z)({
          isReferred: isReferer,
          realestateId: parseInt("".concat(propertiesId)),
          idSelected: codeReferer ? parseInt(codeReferer) : undefined,
          isAgentReferer: Boolean(isAgentReferer),
          isAgencyReferer: Boolean(isAgencyReferer),
          type: lead_type_enum/* C_LEAD_TYPE.MAIL */.Pk.MAIL
        })));
      }
    }
  };

  (0,react.useEffect)(function () {
    var hasClamping = function hasClamping(el) {
      var clientHeight = el.clientHeight,
          scrollHeight = el.scrollHeight;
      return clientHeight !== scrollHeight;
    };

    var checkButtonAvailability = function checkButtonAvailability() {
      if (refDescription !== null && refDescription !== void 0 && refDescription.current) {
        // Save current state to reapply later if necessary.
        var hadClampClass = refDescription === null || refDescription === void 0 ? void 0 : refDescription.current.classList.contains("clamp"); // Make sure that CSS clamping is applied if aplicable.

        if (!hadClampClass) refDescription === null || refDescription === void 0 ? void 0 : refDescription.current.classList.add("clamp"); // Check for clamping and show or hide button accordingly.

        setShowButton(hasClamping(refDescription === null || refDescription === void 0 ? void 0 : refDescription.current)); // Sync clamping with local state.

        if (!hadClampClass) refDescription === null || refDescription === void 0 ? void 0 : refDescription.current.classList.remove("clamp");
      }
    };

    var debouncedCheck = lodash_default().debounce(checkButtonAvailability, 50);

    checkButtonAvailability();
    window.addEventListener("resize", debouncedCheck);
    return function () {
      window.removeEventListener("resize", debouncedCheck);
    };
  }, [refDescription]); // const loanBtnAnchor = any;

  function calculatorBtnAnchor() {
    if (data.business_type.search(saleRegex) !== -1 || data.alternate_price > 0) {
      return (0,emotion_react_browser_esm/* jsx */.tZ)(LoanCalculatorAnchor, {
        onClick: handleClick,
        className: "calcula-tu-cuota"
      }, (0,emotion_react_browser_esm/* jsx */.tZ)(IconCalculator, {
        src: "/icons/icon_calculator_remax.svg"
      }), translation("anchorToCalculator"));
    }

    return null;
  }

  return (0,emotion_react_browser_esm/* jsx */.tZ)(Wrapper, {
    isRent: data.business_type.search(rentRegex) !== -1
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(DetailsProperty, null, (0,emotion_react_browser_esm/* jsx */.tZ)(DetailsHeader, null, (0,emotion_react_browser_esm/* jsx */.tZ)(DetailsTitle, null, (0,emotion_react_browser_esm/* jsx */.tZ)(DetailsSubtitleLight, null, sector), data.realstate_type, " "), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    alignItems: "center"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(DetailsSubtitle, null, renderSector, " ", city), calculatorBtnAnchor()), (0,emotion_react_browser_esm/* jsx */.tZ)(DetailsFeatures, null, getFeatures(data).map(function (item, index) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
      key: index,
      title: item.label,
      arrow: true,
      "aria-label": item.label
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(DetailsFeaturesItem, {
      key: index
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(DetailsFeaturesIcon, {
      src: item.icon
    }), item.value));
  }), data.realstate_type == "Proyecto" && data.trust_name && (0,emotion_react_browser_esm/* jsx */.tZ)(Fideo, {
    src: "/icons/fideicomiso.svg"
  }))), data.description && (0,emotion_react_browser_esm/* jsx */.tZ)(DetailsDescription, null, (0,emotion_react_browser_esm/* jsx */.tZ)(DetailsSection_Title, null, translation("description")), (0,emotion_react_browser_esm/* jsx */.tZ)(sanitize_html/* default */.Z, {
    className: classnames_default()(clamped && "clamp"),
    html: data.description,
    setRefDescription: setRefDescription
  }), showButton && (0,emotion_react_browser_esm/* jsx */.tZ)(ToggleDescription, {
    onClick: handleToggleDescription
  }, clamped ? translation("readMore") : translation("readLess"))), videosList !== null && videosList !== void 0 && videosList.length ? (0,emotion_react_browser_esm/* jsx */.tZ)(DetailsDescription, null, (0,emotion_react_browser_esm/* jsx */.tZ)(DetailsSection_Title, null, translation("videos.title")), (0,emotion_react_browser_esm/* jsx */.tZ)(YoutubeEmbed, {
    src: videosList[0].path
  }), !clampedVideos ? videosList.slice(1).map(function (video) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(YoutubeEmbed, {
      key: video.id,
      src: video.path
    });
  }) : null, (videosList === null || videosList === void 0 ? void 0 : videosList.length) > 1 ? (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)("br", null), (0,emotion_react_browser_esm/* jsx */.tZ)(ToggleDescription, {
    onClick: handleToggleVideosClamp
  }, clampedVideos ? translation("videos.see_more") : translation("videos.see_less"))) : null) : null, (0,emotion_react_browser_esm/* jsx */.tZ)(DetailsImprovements, null, (0,emotion_react_browser_esm/* jsx */.tZ)(DetailsSection_Title, null, translation("features")), (0,emotion_react_browser_esm/* jsx */.tZ)(DetailsImprovementsContainer, null, renderImprovements(data)))), (0,emotion_react_browser_esm/* jsx */.tZ)(DetailsAgent, null, (0,emotion_react_browser_esm/* jsx */.tZ)(agent_detail, {
    handleMessageButton: handleOpenModal,
    setExtraDataLayer: setExtraDataLayer
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(contact_agent_dialog/* default */.Z, {
    onCallBackSubmit: onCallBackSubmitContactModal,
    open: open,
    onClose: handleCloseModal,
    entity_info: (_router$query = router.query) !== null && _router$query !== void 0 && _router$query.areferer ? {
      id: (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.areferer
    } : selectedAgent,
    isAgency: Boolean((_router$query3 = router.query) !== null && _router$query3 !== void 0 && _router$query3.areferer ? 1 : 0),
    realestateId: realestateId,
    classNameModalButton: "enviar-formulario-propiedad",
    defaultMessage: translation("agentContact.defaultMessage"),
    extraDataLayer: extraDataLayer
  }));
}

var YoutubeEmbed = function YoutubeEmbed(_ref) {
  var src = _ref.src;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(YoutubeIframe, {
    src: src,
    title: "YouTube video player",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    allowFullScreen: true
  });
};

var YoutubeIframe = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("iframe",  true ? {
  target: "e1422del22"
} : 0)( true ? {
  name: "12tekmi",
  styles: "width:100%;max-width:560px;aspect-ratio:16/9;border:none"
} : 0);

var Fideo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "e1422del21"
} : 0)( true ? {
  name: "1e7f5y3",
  styles: "width:140px;position:relative;bottom:-10px;height:auto"
} : 0);

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1422del20"
} : 0)("display:grid;grid-template-columns:1fr 0.4fr;column-gap:3rem;padding-bottom:", function (props) {
  return props.isRent ? "0" : "100px";
}, ";justify-content:space-between;@media screen and (max-width: 991px){grid-template-columns:1fr;}" + ( true ? "" : 0));

var DetailsProperty = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1422del19"
} : 0)( true ? {
  name: "15l6l6y",
  styles: "width:100%;@media screen and (max-width: 991px){width:100%;}"
} : 0);

var DetailsHeader = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1422del18"
} : 0)( true ? {
  name: "1u4dskf",
  styles: "border-bottom:1px solid #cbcbcb;margin-bottom:30px"
} : 0);

var DetailsTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h1",  true ? {
  target: "e1422del17"
} : 0)("font-size:", 36 / 16 + "rem", ";font-weight:500;margin-bottom:10px;color:black;padding-right:50px;line-height:60px;@media screen and (max-width: 991px){padding-right:0;}@media screen and (max-width: 400px){font-size:2rem;line-height:2rem;}" + ( true ? "" : 0));

var DetailsSubtitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1422del16"
} : 0)("font-size:", 17 / 16 + "rem", ";color:var(----color-brand-grey-main);font-weight:500;text-transform:capitalize;display:inline-block;margin-right:30px;@media screen and (max-width: 767px){display:block;margin-bottom:20px;margin-right:0;}" + ( true ? "" : 0));

var LoanCalculatorAnchor = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1422del15"
} : 0)( true ? {
  name: "18w4gwn",
  styles: "border:1px solid var(--color-brand-blue-secondary);border-radius:50px;padding:10px 15px;color:var(--color-brand-blue-secondary);font-weight:bold;font-size:14px;text-transform:uppercase;line-height:0;cursor:pointer;margin-top:5px;display:inline-block"
} : 0);

var IconCalculator = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "e1422del14"
} : 0)( true ? {
  name: "18a4g8y",
  styles: "vertical-align:middle;margin-right:3px;max-width:20px"
} : 0);

var DetailsSubtitleLight = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1422del13"
} : 0)( true ? {
  name: "15v3da",
  styles: "font-weight:300;text-transform:capitalize;margin-right:10px"
} : 0);

var DetailsFeatures = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e1422del12"
} : 0)( true ? {
  name: "1thdd9e",
  styles: "margin:30px 0;display:flex;list-style:none;@media screen and (max-width: 385px){flex-wrap:wrap;}"
} : 0);

var ToggleDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1422del11"
} : 0)( true ? {
  name: "4wkc5c",
  styles: "border:1px solid var(--color-brand-blue-secondary);border-radius:50px;padding:15px 20px;color:var(--color-brand-blue-secondary);font-weight:bold;font-size:14px;text-transform:uppercase;line-height:0;cursor:pointer;margin-top:20px;display:inline-block"
} : 0);

var DetailsFeaturesItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "e1422del10"
} : 0)("margin-right:25px;font-weight:500;font-size:", 13 / 16 + "rem", ";color:#afb5bc;display:flex;align-items:flex-end;@media screen and (max-width: 385px){margin-right:20px;margin-top:10px;margin-bottom:10px;}" + ( true ? "" : 0));

var DetailsFeaturesIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "e1422del9"
} : 0)( true ? {
  name: "108qtvb",
  styles: "width:35px;height:35px;vertical-align:baseline;margin-bottom:-5px;margin-right:10px"
} : 0);

var DetailsSection_Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h3",  true ? {
  target: "e1422del8"
} : 0)("font-size:", 22 / 16 + "rem", ";font-weight:700;margin-bottom:10px;color:black;" + ( true ? "" : 0));

var DetailsImprovements = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1422del7"
} : 0)( true ? "" : 0);

var DetailsImprovementsContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1422del6"
} : 0)( true ? {
  name: "u4s7v9",
  styles: "display:grid;grid-template-columns:50% 50%"
} : 0);

var DetailsImprovementColumns = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1422del5"
} : 0)( true ? {
  name: "1lvdbkc",
  styles: "display:grid;grid-template-columns:100%;gap:25px 0"
} : 0);

var DetailsImprovementsItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1422del4"
} : 0)( true ? {
  name: "1t29t6p",
  styles: "width:50%"
} : 0);

var ImprovementItemTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h4",  true ? {
  target: "e1422del3"
} : 0)( true ? {
  name: "1593d4t",
  styles: "font-size:1rem;font-weight:700;margin-bottom:5px;color:black;text-transform:uppercase"
} : 0);

var ImprovementItemDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1422del2"
} : 0)( true ? {
  name: "g7izzx",
  styles: "color:var(--color-brand-grey-secondary);font-size:1rem;font-weight:500;white-space:break-spaces"
} : 0);

var DetailsAgent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1422del1"
} : 0)( true ? {
  name: "1tfv04q",
  styles: "width:100%;padding-top:150px;@media screen and (max-width: 991px){width:100%;}"
} : 0);

var DetailsDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1422del0"
} : 0)( true ? {
  name: "1fzbs5s",
  styles: "border-bottom:1px solid #cbcbcb;margin-bottom:30px;padding-bottom:30px;p{margin:10px 0px;}& .clamp{-webkit-line-clamp:10;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden;text-overflow:ellipsis;overflow-wrap:break-word;}"
} : 0);

/* harmony default export */ var propiedad_DetailsSection = (DetailsSection);

/***/ }),

/***/ 4332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ propiedad_LoanCalculatorDetails; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./shared/components/loan-calculator/index.tsx + 1 modules
var loan_calculator = __webpack_require__(15702);
// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(5678);
;// CONCATENATED MODULE: ./custom-hooks/useReadSessionStorage.hook.ts
// Custom hook made using https://usehooks-ts.com/react-hook/use-read-local-storage as example



function useReadSessionStorage(key) {
  // Get from session storage then
  // parse stored json or return initialValue
  var readValue = (0,react.useCallback)(function () {
    if (false) {}

    try {
      var item = window.sessionStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.warn("Error reading sessionStorage key \u201C".concat(key, "\u201D:"), error);
      return null;
    }
  }, [key]); // State to store our value
  // Pass initial state function to useState so logic is only executed once

  var _useState = (0,react.useState)(readValue),
      storedValue = _useState[0],
      setStoredValue = _useState[1]; // Listen if sessionStorage changes


  (0,react.useEffect)(function () {
    setStoredValue(readValue()); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var handleStorageChange = (0,react.useCallback)(function (event) {
    if (event !== null && event !== void 0 && event.key && event.key !== key) {
      return;
    }

    setStoredValue(readValue());
  }, [key, readValue]); // this only works for other documents, not the current one

  (0,esm/* useEventListener */.OR)("storage", handleStorageChange); // this is a custom event, triggered in writeValueToLocalStorage
  // See: useSessionStorage() https://usehooks-ts.com/react-hook/use-session-storage

  (0,esm/* useEventListener */.OR)("session-storage", handleStorageChange);
  return storedValue;
}

/* harmony default export */ var useReadSessionStorage_hook = (useReadSessionStorage);
// EXTERNAL MODULE: ./shared/models/adapters/loan.adapter.ts
var loan_adapter = __webpack_require__(13306);
// EXTERNAL MODULE: ./shared/models/const/pages-path.ts
var pages_path = __webpack_require__(1283);
// EXTERNAL MODULE: ./shared/components-pages/propiedad/context/DetailPropertyContext.tsx + 1 modules
var DetailPropertyContext = __webpack_require__(74343);
// EXTERNAL MODULE: ./custom-hooks/useLeadCountMutation.tsx + 2 modules
var useLeadCountMutation = __webpack_require__(26102);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components-pages/propiedad/LoanCalculatorDetails.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var saleRegex = new RegExp("Venta", "gi");

function LoanCalculatorDetails(props) {
  var _useDetailPropertyCon = (0,DetailPropertyContext/* useDetailPropertyContextHook */.U)(),
      propertyDetail = _useDetailPropertyCon.propertyDetail;

  var _useLeadCountMutation = (0,useLeadCountMutation/* default */.Z)(),
      ADD_LEAD_COUNT_M = _useLeadCountMutation.ADD_LEAD_COUNT_M;

  var data = props.data,
      isCollection = props.isCollection;
  var router = (0,next_router.useRouter)();
  var code = useReadSessionStorage_hook("code");

  if (data == undefined) {
    return null;
  }

  if (data.business_type.search(saleRegex) === -1 && data.alternate_price <= 0) {
    return null;
  }

  var onSubmit = function onSubmit(values) {
    var agentCode = {};

    if (code && code.type) {
      agentCode = (0,defineProperty/* default */.Z)({}, code.type, code.id);
    }

    var queryValues = (0,loan_adapter/* loanUrlValuesAdapter */._S)(_objectSpread(_objectSpread(_objectSpread({}, values), agentCode), {}, {
      realestateId: data.id,
      propertyValue: data.price,
      currency: data.currency.symbol.toLowerCase()
    }));
    var url = pages_path/* CPagesPath.es.loan_form */.K.es.loan_form + "?" + queryValues + "#loanForm";
    router.push(url);
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(Wrapper, {
    isCollection: isCollection,
    id: "loanCalculator"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "container"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(loan_calculator/* default */.Z, {
    initialPrice: data.price,
    currency: data.currency,
    disableLoanAmount: true,
    onSubmit: onSubmit
  })));
}

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "efff3m70"
} : 0)("background-color:var(--color-brand-bg-secondary);scroll-margin:40px;padding:", function (props) {
  return props.isCollection ? " 100px 0px 0px" : "47px 0px 0px";
}, ";" + ( true ? "" : 0));

/* harmony default export */ var propiedad_LoanCalculatorDetails = (LoanCalculatorDetails);

/***/ }),

/***/ 648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ album_section; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./custom-hooks/redux.hooks.ts
var redux_hooks = __webpack_require__(99109);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./api/realestate.request.ts + 1 modules
var realestate_request = __webpack_require__(13897);
// EXTERNAL MODULE: ./shared/components/property-card/withAdapter.tsx
var withAdapter = __webpack_require__(34175);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(50657);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(37645);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(6514);
// EXTERNAL MODULE: ./shared/components/Button/index.tsx
var Button = __webpack_require__(66621);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/virtual-tour-dialog/index.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






function VirtualTourDialog(props) {
  var open = props.open,
      onClose = props.onClose,
      src = props.src;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(StyledDialog, {
    open: open,
    maxWidth: "lg"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(StyledHeader, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    variant: "text",
    colortext: "--color-brand-grey-secondary",
    onClick: onClose
  }, "Cerrar")), (0,emotion_react_browser_esm/* jsx */.tZ)(StyledContent, null, (0,emotion_react_browser_esm/* jsx */.tZ)("iframe", {
    width: "100%",
    height: "100%",
    src: "".concat(src, "&play=0&qs=1"),
    frameBorder: "0",
    allowFullScreen: true
  })));
}

/* harmony default export */ var virtual_tour_dialog = (VirtualTourDialog);

var StyledDialog = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Dialog/* default */.Z,  true ? {
  target: "e60c4c42"
} : 0)( true ? {
  name: "1ns6ohb",
  styles: "& .MuiDialog-paper{background-color:#efeff1;border-radius:20px;width:60%;height:500px;@media screen and (max-width: 991px){width:90%;}@media screen and (max-width: 500px){width:100%;height:300px;margin-right:0;margin-left:0;}}"
} : 0);

var StyledHeader = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(DialogTitle/* default */.Z,  true ? {
  target: "e60c4c41"
} : 0)( true ? {
  name: "8s2xng",
  styles: "text-align:right;font-size:13px;color:var(--color-brand-grey-main)"
} : 0);

var StyledContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(DialogContent/* default */.Z,  true ? {
  target: "e60c4c40"
} : 0)( true ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : 0);
;// CONCATENATED MODULE: ./shared/components-pages/propiedad/album-section/styles/index.ts


function styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var AlbumCodeShareCss =  true ? {
  name: "1vcob1d",
  styles: "display:flex;justify-content:center;align-items:center"
} : 0;
var AlbumActivePreviewItemSharedCss =  true ? {
  name: "bxg4qt",
  styles: "background-size:cover!important;background-repeat:no-repeat!important;background-position:center!important"
} : 0;
var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1u2kvbf0"
} : 0)( true ? {
  name: "plh83b",
  styles: "margin:100px 0 -50px;margin-top:0px;width:100%;@media screen and (max-width: 991px){margin-bottom:30px;}@media screen and (max-width: 770px){padding-top:100px;}@media screen and (max-width: 570px){padding-top:70px;}"
} : 0);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./shared/components/property-card/favoriteButton.tsx + 1 modules
var favoriteButton = __webpack_require__(2);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Menu/Menu.js + 5 modules
var Menu = __webpack_require__(35294);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(18972);
// EXTERNAL MODULE: ./node_modules/react-icons/fa6/index.mjs
var fa6 = __webpack_require__(86204);
// EXTERNAL MODULE: ./node_modules/react-share/es/WhatsappShareButton.js
var WhatsappShareButton = __webpack_require__(12834);
// EXTERNAL MODULE: ./node_modules/react-share/es/WhatsappIcon.js
var WhatsappIcon = __webpack_require__(69275);
// EXTERNAL MODULE: ./node_modules/react-share/es/TwitterShareButton.js
var TwitterShareButton = __webpack_require__(46616);
// EXTERNAL MODULE: ./node_modules/react-share/es/TelegramShareButton.js
var TelegramShareButton = __webpack_require__(38168);
// EXTERNAL MODULE: ./node_modules/react-share/es/TelegramIcon.js
var TelegramIcon = __webpack_require__(44276);
// EXTERNAL MODULE: ./node_modules/react-share/es/LinkedinShareButton.js
var LinkedinShareButton = __webpack_require__(53597);
// EXTERNAL MODULE: ./node_modules/react-share/es/LinkedinIcon.js
var LinkedinIcon = __webpack_require__(37332);
// EXTERNAL MODULE: ./node_modules/react-share/es/EmailShareButton.js
var EmailShareButton = __webpack_require__(38980);
// EXTERNAL MODULE: ./node_modules/react-share/es/EmailIcon.js
var EmailIcon = __webpack_require__(66339);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./store/property-detail/index.tsx
var property_detail = __webpack_require__(78595);
// EXTERNAL MODULE: ./custom-hooks/data-layer-event.hook.ts
var data_layer_event_hook = __webpack_require__(65198);
// EXTERNAL MODULE: ./custom-hooks/useGetPersintParamas.hook.ts
var useGetPersintParamas_hook = __webpack_require__(53541);
;// CONCATENATED MODULE: ./shared/components/shared-network/index.tsx



function shared_network_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












function SharedNetWork(props) {
  var _React$useState = react.useState(null),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var _usePropertyDetail = (0,property_detail/* usePropertyDetail */.qd)(),
      property = _usePropertyDetail.property;

  var referer = (0,useGetPersintParamas_hook/* default */.Z)({
    onlyId: true
  });
  var router = (0,next_router.useRouter)();

  var _useDataLayerEvent = (0,data_layer_event_hook/* default */.Z)(),
      event = _useDataLayerEvent.event;

  var open = Boolean(anchorEl);

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  var values = {
    title: "",
    shareUrl:  true ? window.location.href : 0
  };

  var handleShare = function handleShare(platform) {
    var body = {
      codigo_de_propiedad: property === null || property === void 0 ? void 0 : property.id,
      ubicacion_propiedad: "".concat(property.address, " ").concat(property.sector, " ").concat(property.city),
      codigo_de_referido: referer,
      plataforma: platform
    };
    event({
      event_name: "share_remax_network",
      body: body
    }); // setAnchorEl(null);

    if (platform == "Email") {
      window.location.href = "mailto:?subject=Hola le comparto esta propiedad &body=".concat(values.shareUrl);
    }
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
    sx: {
      display: "flex",
      alignItems: "center",
      textAlign: "center"
    }
  }, /*#__PURE__*/react.cloneElement(props.children, {
    onClick: handleClick,
    id: "share_property"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Menu/* default */.Z, {
    anchorEl: anchorEl,
    id: "account-menu",
    open: open,
    onClose: handleClose,
    onClick: handleClose,
    PaperProps: paperProps,
    transformOrigin: {
      horizontal: "right",
      vertical: "top"
    },
    anchorOrigin: {
      horizontal: "right",
      vertical: "bottom"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(CustomMenu, null, (0,emotion_react_browser_esm/* jsx */.tZ)(WhatsappShareButton/* default */.Z, {
    onClick: function onClick() {
      return handleShare("WhatsApp");
    },
    url: values.shareUrl,
    title: values.title,
    separator: " "
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(WhatsappIcon/* default */.Z, {
    size: 32,
    round: true
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(TwitterShareButton/* default */.Z, {
    url: values.shareUrl,
    title: values.title,
    onClick: function onClick() {
      return handleShare("Twitter");
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(fa6/* FaXTwitter */.LCd, {
    size: 32,
    color: "#2e2e2e"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(TelegramShareButton/* default */.Z, {
    url: values.shareUrl,
    title: values.title,
    onClick: function onClick() {
      return handleShare("Telegram");
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(TelegramIcon/* default */.Z, {
    size: 32,
    round: true
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(LinkedinShareButton/* default */.Z, {
    url: values.shareUrl,
    onClick: function onClick() {
      return handleShare("Linkedin");
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(LinkedinIcon/* default */.Z, {
    size: 32,
    round: true
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(EmailShareButton/* default */.Z, {
    onClick: function onClick() {
      return handleShare("Email");
    },
    url: values.shareUrl,
    subject: values.title,
    body: "body"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(EmailIcon/* default */.Z, {
    size: 32,
    round: true
  })))));
}
var paperProps = {
  elevation: 0,
  sx: {
    overflow: "visible",
    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
    mt: 1.5,
    "& .MuiAvatar-root": {
      width: 32,
      height: 32,
      ml: -0.5,
      mr: 1
    },
    "&:before": {
      content: '""',
      display: "block",
      position: "absolute",
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: "background.paper",
      transform: "translateY(-50%) rotate(45deg)",
      zIndex: 0
    }
  }
};

var CustomMenu = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(MenuItem/* default */.Z,  true ? {
  target: "er5rb8q0"
} : 0)( true ? {
  name: "1h4qzeo",
  styles: "display:grid;grid-template-columns:repeat(3, 40px);grid-template-rows:repeat(2, 40px)"
} : 0);
;// CONCATENATED MODULE: ./shared/components-pages/propiedad/album-section/components/AlbumHeader.tsx


function AlbumHeader_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var AlbumHeader = function AlbumHeader(_ref2) {
  var isCollection = _ref2.isCollection,
      id = _ref2.id,
      isFavorite = _ref2.isFavorite,
      onFavoriteChange = _ref2.onFavoriteChange,
      detail = _ref2.detail,
      parent_id = _ref2.parent_id;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    alignItems: "flex-end",
    width: "100%"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: "auto"
  }, isCollection && (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumCode, {
    isCollection: isCollection
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumCodeText, null, "COLLECTION \xAE "), "C\xF3digo: ", id), !isCollection && (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumCode, null, "C\xF3digo: ", id)), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    flex: 1
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: "auto"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumLikeContainer, null, (0,emotion_react_browser_esm/* jsx */.tZ)(favoriteButton/* default */.Z, {
    fontSize: "medium",
    borderColor: "error",
    size: 50,
    parent_id: parent_id,
    is_favorite: isFavorite,
    detail: detail,
    onChangeCallback: onFavoriteChange
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumLikeText, null, isFavorite ? "Quitar" : "Guardar"))), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: "auto"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(SharedNetWork, null, (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumShare, null, (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumShareIcon, {
    src: "/icons/icon_share_remaxrd_white.svg",
    alt: "Icono Compartir"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumShareText, null, "Compartir")))));
};

var AlbumLikeContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "excaw3e6"
} : 0)( true ? {
  name: "39fapq",
  styles: "display:flex;background-color:white;border-radius:20px 0 0 0;align-items:center;justify-content:center;border:1px solid #ccc;align-items:center;width:130px;height:45px;padding:0 10px;@media screen and (max-width: 991px){width:80px;height:50px;}@media screen and (max-width: 570px){right:0;}"
} : 0);

var _ref =  true ? {
  name: "4img43",
  styles: "background-color:#ec1c25"
} : 0;

var AlbumCode = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "excaw3e5"
} : 0)(AlbumCodeShareCss, ";background-color:var(--color-brand-blue-secondary);text-align:center;padding:1rem 1.5rem;color:var(--color-brand-bg-secondary);font-weight:500;font-size:", 17 / 16 + "rem", ";text-decoration:none;border-radius:20px 20px 0 0;display:inline-block;width:auto;margin-top:40px;", function (props) {
  if (props.isCollection) {
    return _ref;
  }
}, "@media screen and (max-width: 991px){white-space:nowrap;font-size:0.9rem;}" + ( true ? "" : 0));

var AlbumCodeText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "excaw3e4"
} : 0)( true ? {
  name: "1vgdfxe",
  styles: "color:var(--color-brand-bg-secondary);@media screen and (max-width: 570px){display:none;}"
} : 0);

var AlbumShare = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "excaw3e3"
} : 0)(AlbumCodeShareCss, ";background-color:var(--color-brand-blue-main);border-radius:0px 20px 0 0;font-weight:500;display:flex;gap:10px;font-size:", 14 / 16 + "rem", ";padding:0 10px;height:45px;cursor:pointer;&:hover{color:var(--color-brand-grey-main);}@media screen and (max-width: 991px){width:80px;height:50px;}" + ( true ? "" : 0));

var AlbumLikeText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "excaw3e2"
} : 0)( true ? {
  name: "16z5zrr",
  styles: "font-size:14px;font-weight:500;color:var(--color-brand-blue-main);margin-right:10px;@media screen and (max-width: 991px){display:none;}"
} : 0);

var AlbumShareText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "excaw3e1"
} : 0)( true ? {
  name: "1qvq1yl",
  styles: "color:#fff;padding-top:5px;@media screen and (max-width: 991px){display:none;}"
} : 0);

var AlbumShareIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "excaw3e0"
} : 0)( true ? {
  name: "1ov7nyw",
  styles: "color:var(--color-brand-red-main);margin-left:5px;margin-top:5px;width:20px;height:20px;vertical-align:middle;border-style:none;@media screen and (max-width: 991px){margin-left:0;}"
} : 0);

/* harmony default export */ var components_AlbumHeader = (AlbumHeader);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(36864);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowBackIosNew.js
var ArrowBackIosNew = __webpack_require__(78298);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowForwardIos.js
var ArrowForwardIos = __webpack_require__(13379);
// EXTERNAL MODULE: ./shared/components/slick-slider/index.tsx
var slick_slider = __webpack_require__(84256);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(88078);
// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(72679);
// EXTERNAL MODULE: ./node_modules/react-photo-view/dist/react-photo-view.module.js
var react_photo_view_module = __webpack_require__(71455);
;// CONCATENATED MODULE: ./shared/components-pages/propiedad/album-section/components/AlbumPictures.tsx




function AlbumPictures_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










function CustomNextArrow(props) {
  return (0,emotion_react_browser_esm/* jsx */.tZ)(NextArrow, props);
}

function CustomPrevArrow(props) {
  return (0,emotion_react_browser_esm/* jsx */.tZ)(PrevArrow, props);
}

var AlbumPictures = function AlbumPictures(_ref) {
  var pictures = _ref.pictures,
      mainImage = _ref.mainImage,
      onMainImageChange = _ref.onMainImageChange,
      data = _ref.data;
  var isMobile = (0,useMediaQuery/* default */.Z)("(max-width: 991px)");

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      isVisible = _React$useState2[0],
      setIsVisible = _React$useState2[1];

  var _React$useState3 = react.useState(0),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      index = _React$useState4[0],
      setIndex = _React$useState4[1];

  var uniquePictures = react.useMemo(function () {
    return pictures;
  }, [pictures]); // Preparar las imágenes para el PhotoSlider

  var photoImages = react.useMemo(function () {
    return uniquePictures.map(function (picture) {
      return {
        src: picture.pictures,
        key: picture.id
      };
    });
  }, [uniquePictures]);
  var verticalSliderSettings = {
    slidesToShow: 4,
    slidesToScroll: 3,
    vertical: true,
    verticalSwiping: true,
    swipeToSlide: true,
    nextArrow: (0,emotion_react_browser_esm/* jsx */.tZ)(CustomNextArrow, null),
    prevArrow: (0,emotion_react_browser_esm/* jsx */.tZ)(CustomPrevArrow, null)
  };
  var sliderSettings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    nextArrow: (0,emotion_react_browser_esm/* jsx */.tZ)(CustomNextArrow, null),
    prevArrow: (0,emotion_react_browser_esm/* jsx */.tZ)(CustomPrevArrow, null)
  };
  return (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumBody, null, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    hidden: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(react_photo_view_module/* PhotoSlider */.Ce, {
    speed: function speed() {
      return 400;
    },
    easing: function easing(type) {
      return "cubic-bezier(0.25, 0.8, 0.25, 1)";
    },
    maskOpacity: 0.8,
    loop: true,
    images: uniquePictures.map(function (item) {
      return {
        src: item.pictures,
        key: item.id
      };
    }),
    visible: isVisible,
    onClose: function onClose() {
      return setIsVisible(false);
    },
    onIndexChange: function onIndexChange(index) {
      return setIndex(index);
    },
    index: index
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(HorizontalSliderMobile, sliderSettings, uniquePictures.map(function (picture) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumImage, {
      src: picture.pictures,
      alt: "".concat(data.realstate_type, " ").concat(data.sector),
      key: picture.id,
      delayTime: 5000,
      onClick: function onClick() {
        setIsVisible(true);
        setIndex(uniquePictures.findIndex(function (item) {
          return item.pictures === picture.pictures;
        }));
      },
      placeholder: (0,emotion_react_browser_esm/* jsx */.tZ)(Skeleton/* default */.Z, {
        variant: "rectangular",
        animation: "wave",
        style: {
          display: "block",
          width: "100%",
          height: "100%"
        }
      })
    });
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(MainImageContainer, null, uniquePictures.map(function (picture) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumContentActive, {
      key: picture.id,
      style: {
        display: (mainImage === null || mainImage === void 0 ? void 0 : mainImage.pictures) === (picture === null || picture === void 0 ? void 0 : picture.pictures) ? "block" : "none"
      },
      onClick: function onClick() {
        setIsVisible(true);
        setIndex(uniquePictures.findIndex(function (item) {
          return item.pictures === picture.pictures;
        }));
      }
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumActive, {
      delayTime: 5000,
      src: mainImage === null || mainImage === void 0 ? void 0 : mainImage.pictures,
      alt: "".concat(data.realstate_type, " ").concat(data.sector),
      placeholder: (0,emotion_react_browser_esm/* jsx */.tZ)(Skeleton/* default */.Z, {
        variant: "rectangular",
        animation: "wave",
        style: {
          display: "block",
          width: "100%",
          height: "100%"
        }
      })
    }));
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumPreview, null, (0,emotion_react_browser_esm/* jsx */.tZ)(VerticalSlider, (0,esm_extends/* default */.Z)({}, verticalSliderSettings, {
    infinite: uniquePictures.length < 4 ? false : true
  }), uniquePictures.map(function (picture, index) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
      key: picture.id,
      onClick: function onClick() {
        onMainImageChange(picture); // setIsVisible(true);
        // setIndex(
        //   uniquePictures.findIndex(
        //     (item) => item.pictures === picture.pictures
        //   )
        // );
      }
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumImage, {
      src: picture.pictures,
      alt: "".concat(data.realstate_type, " ").concat(data.sector),
      placeholder: (0,emotion_react_browser_esm/* jsx */.tZ)(Skeleton/* default */.Z, {
        variant: "rectangular",
        animation: "wave",
        style: {
          display: "block",
          width: "100%",
          height: "100%"
        }
      })
    }));
  }))));
};

var MainImageContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eb5r5809"
} : 0)( true ? {
  name: "1614jet",
  styles: "width:80%;height:100%;overflow:hidden;border-radius:0 0 0px 20px"
} : 0);

var AlbumBody = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eb5r5808"
} : 0)( true ? {
  name: "1vsi09h",
  styles: "width:100%;display:flex;flex-wrap:wrap;height:50vw;max-height:600px;justify-content:space-between;align-items:stretch;background-color:var(--color-brand-bg-secondary);border-radius:0 0 20px 20px;position:relative;@media screen and (max-width: 791px){border-radius:0 0 20px 0px;}.slick-list{border-radius:0 0 20px 0px;overflow:hidden;}"
} : 0);

var HorizontalSliderMobile = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(slick_slider/* default */.Z,  true ? {
  target: "eb5r5807"
} : 0)( true ? {
  name: "14xicv7",
  styles: "display:none;height:100%;width:100%;& .slick-list,.slick-track,.slick-slide>div{height:inherit;}& .slick-list{width:inherit;}@media screen and (max-width: 991px){display:block;}"
} : 0);

var VerticalSlider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(slick_slider/* default */.Z,  true ? {
  target: "eb5r5806"
} : 0)( true ? {
  name: "1t123kz",
  styles: "height:100%;& .slick-list{height:100%!important;}& .slick-slide{border:none;&>div{line-height:0;}}& .slick-prev{display:none!important;}"
} : 0);

var NextArrow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ArrowForwardIos/* default */.Z,  true ? {
  target: "eb5r5805"
} : 0)( true ? {
  name: "p2nnul",
  styles: "color:var(--color-brand-blue-main);top:100%;left:50%;transform:translateX(-50%) rotate(90deg);height:26px;width:26px;&:hover{color:var(--color-brand-blue-main);}@media screen and (max-width: 991px){top:50%;transform:rotate(0) translateY(-50%);left:calc(100% - 50px);color:var(--color-brand-bg-secondary);height:50px;width:50px;&:hover{color:var(--color-brand-bg-secondary);}}"
} : 0);

var PrevArrow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ArrowBackIosNew/* default */.Z,  true ? {
  target: "eb5r5804"
} : 0)( true ? {
  name: "t9acec",
  styles: "top:50%;transform:translateY(-50%);left:0;color:var(--color-brand-bg-secondary);height:50px;width:50px;z-index:1;&:hover,&:focus{color:var(--color-brand-bg-secondary);}"
} : 0);

var AlbumContentActive = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eb5r5803"
} : 0)( true ? {
  name: "17qx3ud",
  styles: "width:100%;height:50vw;max-height:600px;cursor:pointer;@media screen and (max-width: 1180px){}@media screen and (max-width: 1054px){}@media screen and (max-width: 991px){display:none;}"
} : 0);

var AlbumActive = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(build.LazyLoadImage,  true ? {
  target: "eb5r5802"
} : 0)( true ? {
  name: "1sbfb9g",
  styles: "object-fit:cover;position:relative;width:100%;height:100%;background:white;@media screen and (max-width: 991px){display:none;}"
} : 0);

var AlbumPreview = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eb5r5801"
} : 0)( true ? {
  name: "1jryiis",
  styles: "width:calc(20% - 10px);height:100%;@media screen and (max-width: 991px){display:none;}"
} : 0);

var AlbumImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(build.LazyLoadImage,  true ? {
  target: "eb5r5800"
} : 0)( true ? {
  name: "r2uq94",
  styles: "object-fit:cover;width:100%;height:145px;margin-bottom:5px;cursor:pointer;@media screen and (max-width: 991px){height:inherit;margin:0;cursor:auto;}"
} : 0);

/* harmony default export */ var components_AlbumPictures = (AlbumPictures);
// EXTERNAL MODULE: ./shared/components/mask-components/index.tsx + 1 modules
var mask_components = __webpack_require__(6107);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
;// CONCATENATED MODULE: ./shared/components-pages/propiedad/album-section/components/AlbumFooter.tsx


function AlbumFooter_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var AlbumFooter = function AlbumFooter(_ref) {
  var data = _ref.data,
      onTourClick = _ref.onTourClick,
      minimum_price = _ref.minimum_price,
      maximum_price = _ref.maximum_price,
      price = _ref.price;
  var t = (0,next_intl_cjs_production_min.useTranslations)("PriceRange");
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Footer, null, Boolean(data.realstate_tour_url) && (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumButton, {
    onClick: onTourClick
  }, "Matterport"), (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumTag, {
    className: data.alternate_price > 0 ? "price-double" : ""
  }, data.alternate_price > 0 && (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumPrice, null, (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumPriceTag, {
    className: "price-double"
  }, "VENTA"), (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumPriceNumber, {
    className: "price-double"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(mask_components/* MoneyInput */.PK, {
    value: data.price,
    prefix: data.currency.symbol + "$",
    displayType: "text"
  }))), (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumPrice, null, (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumPriceTag, {
    className: "price-double"
  }, "ALQUILER"), (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumPriceNumber, {
    className: "price-double"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(mask_components/* MoneyInput */.PK, {
    value: data.alternate_price,
    prefix: data.alternative_currency.symbol + "$",
    displayType: "text"
  })))), data.alternate_price <= 0 && (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumPrice, null, (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumPriceTag, null, data.business_type), (0,emotion_react_browser_esm/* jsx */.tZ)(AlbumPriceNumber, null, maximum_price && minimum_price ? (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(PriceRangeItem, null, t("from"), " ", (0,emotion_react_browser_esm/* jsx */.tZ)(PriceRangeItemPrice, null, minimum_price)), (0,emotion_react_browser_esm/* jsx */.tZ)(PriceRangeItem, null, t("to"), " ", (0,emotion_react_browser_esm/* jsx */.tZ)(PriceRangeItemPrice, null, maximum_price))) : price))));
};

var Footer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e4tim6y7"
} : 0)( true ? {
  name: "c09j1p",
  styles: "width:100%;display:flex;justify-content:flex-end;transform:translateY(2.5rem);@media screen and (max-width: 991px){flex-direction:column;}@media screen and (max-width: 1000px){transform:translateY(0);}@media screen and (max-width: 570px){transform:none;}"
} : 0);

var AlbumButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button/* default */.Z,  true ? {
  target: "e4tim6y6"
} : 0)( true ? {
  name: "16oe6ti",
  styles: "background-color:#969daf;width:169px;height:36px;font-size:1rem;font-weight:400;text-transform:none;line-height:1.15;padding:0;margin:auto 0.7rem;transform:translateX(15px);@media screen and (max-width: 400px){transform:translateX(0);}&:hover{background-color:#969daf;scale:1;}@media screen and (max-width: 991px){border-radius:0 0 10px 10px;margin:0;}"
} : 0);

var AlbumTag = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e4tim6y5"
} : 0)( true ? {
  name: "1jhdrbh",
  styles: "width:18rem;height:auto;background-color:var(--color-brand-bg-secondary);display:flex;flex-wrap:wrap;align-items:center;border-radius:20px;padding:0 20px;display:flex;flex-direction:column;justify-content:center;align-items:center;@media screen and (max-width: 570px){border-radius:0 0 20px 20px;}&.price-double{min-height:106px;padding:10px 20px;gap:10px 20px;}@media screen and (max-width: 991px){width:100%;margin-top:30px;border-radius:20px;}"
} : 0);

var AlbumPrice = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e4tim6y4"
} : 0)( true ? {
  name: "82a6rk",
  styles: "flex:1"
} : 0);

var AlbumPriceTag = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e4tim6y3"
} : 0)("display:block;font-size:1.2rem;font-weight:300;text-transform:uppercase;color:black;&.price-double{font-size:", 14 / 12 + "rem", ";}" + ( true ? "" : 0));

var AlbumPriceNumber = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e4tim6y2"
} : 0)("font-size:1.7rem;font-weight:500;display:block;color:black;&.price-double{font-size:", 16 / 12 + "rem", ";}" + ( true ? "" : 0));

var PriceRangeItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e4tim6y1"
} : 0)( true ? {
  name: "jyertw",
  styles: "font-weight:500;font-size:16px;margin-bottom:2px;text-transform:uppercase;@media (max-width: 500px){font-size:15px;}"
} : 0);

var PriceRangeItemPrice = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e4tim6y0"
} : 0)( true ? {
  name: "67ekn6",
  styles: "font-weight:700;font-size:1.4rem;@media (max-width: 500px){font-size:1.2rem;}"
} : 0);

/* harmony default export */ var components_AlbumFooter = (AlbumFooter);
;// CONCATENATED MODULE: ./shared/components-pages/propiedad/album-section/index.tsx












function AlbumSection(props) {
  var _data$project, _data$project2;

  var data = props.data,
      isCollection = props.isCollection,
      id = props.id;
  var user = (0,redux_hooks/* useAppSelector */.C)(function (_ref) {
    var Auth = _ref.Auth;
    return Auth.user;
  });
  var price = (data === null || data === void 0 ? void 0 : data.currency.symbol) + withAdapter/* moneyFormatter.format */.ed.format(data === null || data === void 0 ? void 0 : data.price);
  var maximum_price = null;
  var minimum_price = null;

  if (data !== null && data !== void 0 && (_data$project = data.project) !== null && _data$project !== void 0 && _data$project.minimum_price && data !== null && data !== void 0 && (_data$project2 = data.project) !== null && _data$project2 !== void 0 && _data$project2.maximum_price) {
    maximum_price = "".concat(data.currency.symbol) + withAdapter/* moneyFormatter.format */.ed.format(data.project.maximum_price);
    minimum_price = "".concat(data.currency.symbol) + withAdapter/* moneyFormatter.format */.ed.format(data.project.minimum_price);
  }

  var cache = [];
  var cleanImages = data.pictures.map(function (picture) {
    if (!cache.includes(picture.pictures)) {
      cache.push(picture.pictures);
      return picture;
    }

    return null;
  });
  var pictures = cleanImages.filter(Boolean);

  var _useState = (0,react.useState)(pictures[0]),
      mainImage = _useState[0],
      setMainImage = _useState[1];

  var _useState2 = (0,react.useState)(false),
      openDialog = _useState2[0],
      setOpenDialog = _useState2[1];

  var _useState3 = (0,react.useState)(data.is_favorite),
      isFavorite = _useState3[0],
      setIsFavorite = _useState3[1];

  var _useMutation = (0,useMutation/* useMutation */.D)(["propertyDetails", id], realestate_request/* getRealestateDetails */.mW, {
    onSuccess: function onSuccess(_ref2) {
      var is_favorite = _ref2.data.is_favorite;
      setIsFavorite(!!is_favorite);
    }
  }),
      mutate = _useMutation.mutate;

  var handleOpen = function handleOpen() {
    setOpenDialog(true);
  };

  var handleClose = function handleClose() {
    setOpenDialog(false);
  };

  var handleMainImageChange = function handleMainImageChange(picture) {
    setMainImage(picture);
  };

  (0,react.useEffect)(function () {
    handleMainImageChange(pictures[0]);
  }, [data.id]);
  (0,react.useEffect)(function () {
    if (user) mutate(id);
  }, [user, mutate, id]);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Wrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(components_AlbumHeader, {
    isCollection: isCollection,
    id: id,
    isFavorite: isFavorite,
    onFavoriteChange: setIsFavorite,
    detail: data,
    parent_id: data.parent_id
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(components_AlbumPictures, {
    pictures: pictures,
    mainImage: mainImage,
    onMainImageChange: handleMainImageChange,
    data: data
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(components_AlbumFooter, {
    data: data,
    onTourClick: handleOpen,
    minimum_price: minimum_price,
    maximum_price: maximum_price,
    price: price
  }), Boolean(data.realstate_tour_url) && (0,emotion_react_browser_esm/* jsx */.tZ)(virtual_tour_dialog, {
    open: openDialog,
    onClose: handleClose,
    src: data.realstate_tour_url
  }));
}

/* harmony default export */ var album_section = (AlbumSection);

/***/ }),

/***/ 74343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ DetailPropertyProvider; },
  "U": function() { return /* binding */ useDetailPropertyContextHook; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./shared/components-pages/propiedad/adapters/propertyDetail.adapter.ts
var propertyDetailAdapter = function propertyDetailAdapter(data) {
  var leadRefererInfo = prepareLeadData(data);
  return {
    leadRefererInfo: leadRefererInfo
  };
};

/* harmony default export */ var propertyDetail_adapter = (propertyDetailAdapter);

var prepareLeadData = function prepareLeadData(data) {
  var params = new URL(data.url).searchParams;
  var referer = params.get("referer");
  var areferer = params.get("areferer");
  var isReferer = Boolean(referer || areferer);
  return {
    propertyId: data.id,
    isReferer: isReferer || false,
    isAgenciesReferer: Boolean(areferer) || false,
    isAgentReferer: Boolean(referer) || false,
    codeReferer: referer || areferer || null
  };
};
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components-pages/propiedad/context/DetailPropertyContext.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var DetailPropertyContext = /*#__PURE__*/(0,react.createContext)({});
var DetailPropertyProvider = function DetailPropertyProvider(_ref) {
  var children = _ref.children,
      data = _ref.data,
      url = _ref.url;
  var propertyDetail = propertyDetail_adapter(_objectSpread(_objectSpread({}, data), {}, {
    url: url
  }));
  return (0,emotion_react_browser_esm/* jsx */.tZ)(DetailPropertyContext.Provider, {
    value: {
      propertyDetail: propertyDetail
    }
  }, children);
};
var useDetailPropertyContextHook = function useDetailPropertyContextHook() {
  var context = (0,react.useContext)(DetailPropertyContext);

  if (!context) {
    throw new Error("useDetailPropertyContext must be used within a DetailPropertyProvider");
  }

  return context;
};

/***/ }),

/***/ 47364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18872);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);


var _excluded = ["message"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





function LoadingBubbles(props) {
  var _props$message = props.message,
      message = _props$message === void 0 ? "Cargando más" : _props$message,
      rest = (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, _excluded);

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Loading, rest, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
    style: {
      marginRight: 15
    }
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("img", {
    src: "/icons/loading-icon.svg",
    alt: "loading"
  })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("span", null, message)));
}

/* harmony default export */ __webpack_exports__["Z"] = (LoadingBubbles);
var spinner = /*#__PURE__*/(0,_emotion_css__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)( true ? {
  name: "b7n1on",
  styles: "0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"
} : 0);
var centerStyles = "\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 9999;\n";

var Loading = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e76jmd50"
} : 0)(function (props) {
  return "\n  width: 100%;\n  background-color: \"transparent\";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 15px;\n  font-weight: 600;\n  color:gray;\n   & img {\n    animation: ".concat(spinner, " 2s infinite;\n  }\n  ").concat(props.center ? centerStyles : '', "\n");
},  true ? "" : 0);

/***/ }),

/***/ 77131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91036);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(sanitize_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


 // https://stackoverflow.com/questions/38663751/how-to-safely-render-html-in-react



var sanitize = function sanitize(dirty, options) {
  return {
    __html: sanitize_html__WEBPACK_IMPORTED_MODULE_2___default()(dirty, options = _objectSpread({}, options))
  };
};

function SanitizeHtml(props) {
  var html = props.html,
      options = props.options,
      className = props.className,
      setRefDescription = props.setRefDescription;
  var refDescription = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);

  if (setRefDescription) {
    setRefDescription(refDescription);
  }

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
    className: className,
    dangerouslySetInnerHTML: sanitize(html, options),
    ref: refDescription
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (SanitizeHtml);

/***/ }),

/***/ 13306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ loanFormValuesAdapter; },
/* harmony export */   "_S": function() { return /* binding */ loanUrlValuesAdapter; },
/* harmony export */   "at": function() { return /* binding */ loanValuesAdapter; }
/* harmony export */ });
/* harmony import */ var shared_models_functions_query_string_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23622);

function loanValuesAdapter(values) {
  var data = {
    full_name: values.full_name,
    nationality: values.nationality,
    cedula: values.identification,
    phone: values.phone,
    cell_phone: values.cellPhone,
    email: values.email,
    current_country_residence: values.residence,
    initial_payment_value: values.initialPayment,
    amount_finance: values.amountFinance,
    comment: values.comment,
    realestate_id: values.realestateId,
    agent: values.agentCode,
    agency_id: values.agencyCode,
    birthdate: values.birthDate,
    "g-recaptcha-response": values.captcha
  };

  if (data.agent == "" || !data.agent) {
    delete data.agent;
  }

  if (data.agency_id == "" || !data.agency_id) {
    delete data.agency_id;
  }

  return data;
}
function loanUrlValuesAdapter(values) {
  var data = {
    // bankRate: values.bankRate,
    // loanDuration: values.loanDuration
    // propertyValue: values.propertyValue,
    initialPayment: values.initialPayment,
    amountFinance: values.loanAmount,
    realestateId: values.realestateId,
    currency: values.currency
  };

  if (values.referer) {
    data.referer = values.referer;
  } else if (values.areferer) {
    data.areferer = values.areferer;
  }

  return (0,shared_models_functions_query_string_helper__WEBPACK_IMPORTED_MODULE_0__/* .queryFormatter */ .Bt)(data);
}
function loanFormValuesAdapter() {
  var _queryParserUrl = (0,shared_models_functions_query_string_helper__WEBPACK_IMPORTED_MODULE_0__/* .queryParserUrl */ .HL)(location.href),
      query = _queryParserUrl.query;

  var data = {
    amountFinance: query.amountFinance || "",
    realestateId: query.realestateId || "",
    initialPayment: query.initialPayment || "",
    agentCode: query.referer || "",
    agencyCode: query.areferer || ""
  };
  return data;
}

/***/ }),

/***/ 78917:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var leadsCounterAdapter = function leadsCounterAdapter(data) {
  var isReferred = data.isReferred ? 1 : 0;
  return {
    params: {
      realestate_id: data.realestateId
    },
    body: {
      type: data.type,
      people_id: data.isAgentReferer || isReferred == 0 ? data.idSelected : undefined,
      is_referred: isReferred,
      agency_id: data.isAgencyReferer ? data.idSelected : undefined
    }
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (leadsCounterAdapter);

/***/ }),

/***/ 27734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pk": function() { return /* binding */ C_LEAD_TYPE; }
/* harmony export */ });
/* unused harmony exports C_IS_CLICKED, O_IS_CLICKED, A_PUBLIC */
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);


var _O_IS_CLICKED;

var C_LEAD_TYPE;

(function (C_LEAD_TYPE) {
  C_LEAD_TYPE[C_LEAD_TYPE["WHATSAPP"] = 1] = "WHATSAPP";
  C_LEAD_TYPE[C_LEAD_TYPE["CALL"] = 2] = "CALL";
  C_LEAD_TYPE[C_LEAD_TYPE["MAIL"] = 3] = "MAIL";
  C_LEAD_TYPE[C_LEAD_TYPE["MORTAGE_REFERRAL"] = 4] = "MORTAGE_REFERRAL";
})(C_LEAD_TYPE || (C_LEAD_TYPE = {}));

var C_IS_CLICKED = {
  WHATSAPP: {
    value: 1,
    id: 1
  },
  CALL: {
    value: 2,
    id: 2
  },
  MAIL: {
    value: 3,
    id: 3
  },
  MORTAGE_REFERRAL: {
    value: 4,
    id: 4
  }
};
var WHATSAPP = C_IS_CLICKED.WHATSAPP,
    CALL = C_IS_CLICKED.CALL,
    MAIL = C_IS_CLICKED.MAIL,
    MORTAGE_REFERRAL = C_IS_CLICKED.MORTAGE_REFERRAL;
var O_IS_CLICKED = (_O_IS_CLICKED = {}, (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_O_IS_CLICKED, WHATSAPP.id, C_IS_CLICKED.WHATSAPP), (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_O_IS_CLICKED, WHATSAPP.value, C_IS_CLICKED.WHATSAPP), (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_O_IS_CLICKED, CALL.id, C_IS_CLICKED.CALL), (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_O_IS_CLICKED, CALL.value, C_IS_CLICKED.CALL), (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_O_IS_CLICKED, MAIL.id, C_IS_CLICKED.MAIL), (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_O_IS_CLICKED, MAIL.value, C_IS_CLICKED.MAIL), (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_O_IS_CLICKED, MORTAGE_REFERRAL.id, C_IS_CLICKED.MORTAGE_REFERRAL), (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_O_IS_CLICKED, MORTAGE_REFERRAL.value, C_IS_CLICKED.MORTAGE_REFERRAL), _O_IS_CLICKED);
var A_PUBLIC = [C_IS_CLICKED.WHATSAPP, C_IS_CLICKED.MORTAGE_REFERRAL];

/***/ }),

/***/ 22868:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 14777:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 99830:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 70209:
/***/ (function() {

/* (ignored) */

/***/ })

}]);